module.exports = __webpack_public_path__ + "static/media/avatar.77cb1542.svg";